
 import * as React from 'react';
 import {createComponent} from '@lit/react';
 
 import {ObiConnectorThreeway as ObiConnectorThreewayElement} from '@oicl/openbridge-webcomponents/dist/icons/icon-connector-threeway.js';
 
 
 

 
 export const ObiConnectorThreeway = createComponent({
   react: React,
   tagName: 'obi-connector-threeway',
   elementClass: ObiConnectorThreewayElement,
   events: {
     
   }
  });
 
 